import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'assetsSource'
})
@Injectable({
  providedIn: 'root'
})
export class AssetsSourcePipe implements PipeTransform {

  private assetsURL: string;

  constructor() {
   // this.assetsURL = `assets/images/${sessionStorage.getItem('brand')}`;
   }

  transform(imgName: string): string {
    return `${this.assetsURL}/${imgName}`;
  }

}